import React from 'react';
import { Typography } from '@/components/common';
import { PhaseStatusBadge } from './phase-status-badge';
import { useCaseStep } from '@/hooks';
import { PhaseName } from '@/interfaces';

interface Props {
	numberPhase: number;
	namePhase: string;
	children: React.ReactNode;
}

export const CardCaseAdministration: React.FC<Props> = ({
	numberPhase,
	namePhase,
	children,
}) => {
	const { isPhaseCompleted } = useCaseStep();
	return (
		<div className="border-grey-10 border-2 flex-1 w-full 2xl:max-w-[71%] rounded-3xl px-[42px] py-8 bg-white space-y-8">
			<div className="flex w-full items-center justify-between">
				<Typography type="regular-18">
					Phase {numberPhase}: {namePhase}
				</Typography>
				<PhaseStatusBadge
					isCompleted={isPhaseCompleted(namePhase as PhaseName)}
				/>
			</div>
			{children}
		</div>
	);
};
